module.exports = __webpack_public_path__ + "img/ys-top-banner.5c2fa75b.png";